import React from 'react';
import _ from 'lodash';
import { IconToggleTooltip } from '../notifications.service';
import { NOTIFICATION_TYPES } from '../notifications.config';
import IconToggle from 'components/base/IconToggle';
import { Flex, Padding } from 'components/base/layout-components';
import {
  openNotificationDuplicationModal,
  shouldOpenNotificationDuplicationModalForSimilar,
  shouldOpenNotificationDuplicationModalForOverLoad
} from './NotificationsCol.service';

const NotificationsCol = ({
  isHeadsUp = false,
  toggleNotificationsForTeam,
  id,
  notificationKey,
  name,
  tooltip,
  headsUpTooltip,
  notificationEnabled,
  headsUpEnabled,
  similarNotifications = [],
  notifications,
  toggleModal,
  notificationsConfig
}) => {
  //gets key of a similar notification that is on or null otherwise
  const notificationsByNotiKey = _.keyBy(notifications, 'notificationKey');

  const getSimilarNotificationTurnedOnKey = () => {
    return similarNotifications.find(similarNotification => {
      const currentNoti = notificationsByNotiKey[similarNotification];
      if (
        currentNoti &&
        (currentNoti.values.warning_enabled ||
          currentNoti.values.violation_enabled)
      ) {
        return similarNotification;
      }
    });
  };

  // Similar - notifications in similarNotifications array
  // overload - same notification but different type : "Heads up" aka warning vs violation aka "Team"

  const onClickHandler = (
    currEnabled,
    currNotificationTypeKey,
    otherNotificationEnabled,
    otherNotificationTypeKey
  ) => {
    const similarNotificationTurnedOnKey = getSimilarNotificationTurnedOnKey();
    const shouldOpenModalForSimilarNoti =
      shouldOpenNotificationDuplicationModalForSimilar({
        currEnabled,
        similarNotifications,
        similarNotificationTurnedOnKey,
        otherNotificationEnabled
      });

    const shouldOpenModalForOverLoadNoti =
      shouldOpenNotificationDuplicationModalForOverLoad({
        otherNotificationEnabled,
        currEnabled
      });

    if (shouldOpenModalForSimilarNoti) {
      openNotificationDuplicationModal({
        currNotificationTypeKey,
        currEnabled,
        name,
        similarNotificationTurnedOnKey,
        notificationsConfig,
        toggleModal,
        toggleNotificationsForTeam,
        notificationKey,
        id,
        modalContent: 'similar',
        otherNotificationTypeKey
      });
    } else if (shouldOpenModalForOverLoadNoti) {
      openNotificationDuplicationModal({
        currNotificationTypeKey,
        currEnabled,
        name,
        similarNotificationTurnedOnKey,
        notificationsConfig,
        toggleModal,
        toggleNotificationsForTeam,
        notificationKey,
        id,
        modalContent: 'overload',
        otherNotificationTypeKey
      });
    } else {
      toggleNotificationsForTeam(
        !currEnabled,
        currNotificationTypeKey,
        id,
        notificationKey,
        name
      );
    }
  };

  return (
    <Flex items='center' justify='center'>
      <Padding l='small' r='small' width='1.75rem'>
        {isHeadsUp && (
          <IconToggle
            name='alarm'
            checkedName='alarmFull'
            size='normal'
            color='shuttleGray'
            checkedColor='malachite'
            isChecked={headsUpEnabled}
            tooltipContent={IconToggleTooltip(
              _.get(NOTIFICATION_TYPES, 'HEADSUP.tooltipTitle', ''),
              headsUpTooltip
            )}
            onClick={() => {
              onClickHandler(
                headsUpEnabled,
                'warningEnabledKey',
                notificationEnabled,
                'violationEnabledKey'
              );
            }}
          />
        )}
      </Padding>
      <Padding l='small' r='small'>
        <IconToggle
          name='notificationChat'
          checkedName='notificationChatFull'
          size='normal'
          color='shuttleGray'
          checkedColor='malachite'
          isChecked={notificationEnabled}
          tooltipContent={IconToggleTooltip(
            _.get(NOTIFICATION_TYPES, 'NOTIFICATIONS.tooltipTitle', ''),
            tooltip
          )}
          onClick={() => {
            onClickHandler(
              notificationEnabled,
              'violationEnabledKey',
              headsUpEnabled,
              'warningEnabledKey'
            );
          }}
        />
      </Padding>
    </Flex>
  );
};

export default NotificationsCol;
